import { render, staticRenderFns } from "./Prestataires.vue?vue&type=template&id=6e5eb56e&scoped=true"
import script from "./Prestataires.vue?vue&type=script&lang=js"
export * from "./Prestataires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5eb56e",
  null
  
)

export default component.exports